import { History } from 'lucide-react';
import { useRecentCustomersStore, type RecentCustomer } from '../stores/recent-customers-store';

/**
 * "Recently accessed" customers — the last 5 customers opened on this browser.
 * Rendered in the Users search column's empty state (hidden once you type).
 * Clicking a row shows that customer as a card in the column via `onOpen`.
 */
export function RecentCustomers({ onOpen }: { onOpen: (recent: RecentCustomer) => void }) {
  const recents = useRecentCustomersStore((s) => s.recents);
  if (!recents.length) return null;

  return (
    <div className="flex flex-col gap-1.5" data-testid="recent-customers">
      <span className="px-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
        {'Recently accessed'}
      </span>
      {recents.map((r) => (
        <button
          key={r.accountId}
          type="button"
          onClick={() => onOpen(r)}
          className="flex items-center gap-2 rounded-lg border bg-card px-3 py-2 text-left text-xs transition-colors hover:bg-accent/50"
          data-testid="recent-customer-item"
        >
          <History className="h-3.5 w-3.5 shrink-0 text-muted-foreground" aria-hidden />
          <span className="flex min-w-0 flex-col">
            <span className="truncate font-medium">{r.companyName ?? r.accountId}</span>
            <span className="truncate text-muted-foreground">{r.ownerEmail ?? '(no owner)'}</span>
          </span>
        </button>
      ))}
    </div>
  );
}
